import React from 'react';
import { StarIcon } from 'lucide-react';
import { Section, Avatar } from './shared';
interface Testimonial {
  initials: string;
  name: string;
  role: string;
  city: string;
  quote: string;
}
const heroTestimonials: Testimonial[] = [{
  initials: 'MG',
  name: 'Martín G.',
  role: 'Agente Independiente',
  city: 'Buenos Aires',
  quote: 'Tenía 3 renovaciones vencidas por semana. Con el sistema de seguimiento del Megapack recuperé 11 pólizas en el primer mes. Nunca más pierdo una renovación.'
}, {
  initials: 'LP',
  name: 'Laura P.',
  role: 'Agente de Seguros',
  city: 'Córdoba',
  quote: 'El guión de manejo de objeciones me cambió la vida. Antes cedía en el precio siempre. Ahora cierro sin descuento y el cliente queda conforme.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  role: 'Agente Independiente',
  city: 'Rosario',
  quote: 'Lo que más me sorprendió fue el protocolo de WhatsApp. Mis clientes ahora saben cuándo y cómo escribirme. Recuperé mis domingos.'
}];
const moreTestimonials: Testimonial[] = [{
  initials: 'CR',
  name: 'Cecilia R.',
  role: 'Megapack PRO + Asistente de IA',
  city: 'Mendoza',
  quote: 'El sistema de renovaciones me salvó la cartera. Recuperé 8 pólizas en las primeras dos semanas que se me iban a vencer. Ese solo módulo ya justificó toda la inversión.'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  role: 'Agente Independiente',
  city: 'Buenos Aires',
  quote: 'Subí mis cierres un 60% en dos meses usando el protocolo de objeciones. Antes cedía en el precio siempre. Ahora cierro sin descuento y el cliente queda satisfecho.'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  role: 'Agente de Seguros',
  city: 'La Plata',
  quote: 'Mis clientes ahora reciben un mensaje de seguimiento profesional y personalizado. Nadie me volvió a decir que era caro. El mensaje lo armo en 2 minutos con el prompt y parece hecho por un agente de alto nivel.'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  role: 'Agente Independiente',
  city: 'Neuquén',
  quote: 'El protocolo de WhatsApp fue un antes y un después. Lo que me llevaba 2 horas respondiendo mensajes ahora lo resuelvo en 20 minutos. Recuperé mis tardes.'
}];
function Stars() {
  return <div className="flex" aria-hidden="true" data-id="element-189" data-mp="1oh2jot2vnqgl">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold text-gold" data-id="element-190" data-mp="1jihr9ftvab2p" data-mpi={i} />)}
    </div>;
}
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <figure className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-6 shadow-sm" data-id="element-191" data-mp="1ek6fv0nxbsid">
      <Stars data-id="element-192" data-mp="19rmuhhizvt30" />
      <blockquote className="mt-4 grow text-[15px] leading-relaxed text-slate-700" data-id="element-193" data-mp="19r3masj5cj26">
        “{t.quote}”
      </blockquote>
      <figcaption className="mt-5 flex items-center gap-3 border-t border-slate-100 pt-4" data-id="element-194" data-mp="14qz32uquta89">
        <Avatar initials={t.initials} data-id="element-195" data-mp="10pne8rft0t14" />
        <div data-id="element-196" data-mp="vt6qhyciogok">
          <div className="font-display font-bold text-navy" data-id="element-197" data-mp="vrlu036n6no2">{t.name}</div>
          <div className="text-sm text-slate-500" data-id="element-198" data-mp="qt0rfx3x3rwg">
            {t.role} · 📍 {t.city}
          </div>
        </div>
      </figcaption>
    </figure>;
}
export function TestimonialsTop() {
  return <Section className="bg-slate-50 py-16 sm:py-20" data-id="element-199" data-mp="37fqnbic7k2x2">
      <div className="text-center" data-id="element-200" data-mp="37efl3myev382">
        <h2 className="font-display text-2xl font-extrabold text-navy sm:text-3xl" data-id="element-201" data-mp="3cf3l2y4mauef">
          Lo que dicen los agentes
        </h2>
        <div className="mt-3 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 shadow-sm ring-1 ring-slate-200" data-id="element-202" data-mp="3ggym01imz5ro">
          <Stars data-id="element-203" data-mp="2jrzdcle541yy" />
          <span className="text-sm font-semibold text-navy" data-id="element-204" data-mp="2jobi9ht1r7i4">4.9/5 calificación (+500 agentes)</span>
        </div>
      </div>
      <div className="mt-10 grid gap-5 sm:grid-cols-3" data-id="element-205" data-mp="2sr46tdauh549">
        {heroTestimonials.map((t, i) => <Card key={i} t={t} data-id="element-206" data-mp="2sp9psa2p1x5g" data-mpi={i} />)}
      </div>
    </Section>;
}
export function TestimonialsMore() {
  return <Section className="bg-slate-50 py-16 sm:py-20" data-id="element-207" data-mp="20zwr8uiqbthb">
      <div className="grid gap-5 sm:grid-cols-2" data-id="element-208" data-mp="20z57cgyhvk6v">
        {moreTestimonials.map((t, i) => <Card key={i} t={t} data-id="element-209" data-mp="250gn7urkgr1v" data-mpi={i} />)}
      </div>
    </Section>;
}